import { render, staticRenderFns } from "./placeAdd.vue?vue&type=template&id=f17cdaa6&scoped=true&"
import script from "./placeAdd.vue?vue&type=script&lang=js&"
export * from "./placeAdd.vue?vue&type=script&lang=js&"
import style0 from "./placeAdd.vue?vue&type=style&index=0&id=f17cdaa6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17cdaa6",
  null
  
)

export default component.exports